import React from 'react';
import { Card, Col, Modal, Row } from 'antd';
import cx from 'classnames';
import { CloseModalIcon } from '@gtintel/platform-atoms';
import EditProjectDetailForm from './components/EditProjectDetailForm';
import styles from './styles.module.scss';
const EditProjectDetailsModal = ({
  hideModal,
  isVisible,
  showModal
}) => {
  return <Modal footer={null} visible={isVisible} onOk={showModal} onCancel={hideModal} title="Edit Project Details" className={cx('proposal-modal', styles.detailProjectModal)} closeIcon={<CloseModalIcon />}>
      <div>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card bordered={false}>
              {isVisible && <EditProjectDetailForm onCancel={hideModal} />}
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>;
};
export default EditProjectDetailsModal;